import React from 'react';
import { Routes, Route, useLocation, Navigate } from 'react-router-dom';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import Home from './pages/Home/Home';
import Demos from './pages/Demos/Demos';
import Pricing from './pages/Pricing/Pricing';
import DemoPage from './pages/Demo/DemoPage';
import ProspectDemoPage from './pages/Demo/ProspectDemoPage';
import AuditPage from './pages/Audit/AuditPage';
import AdminLogin from './pages/admin/AdminLogin';
import AdminLayout from './pages/admin/AdminLayout';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminProspects from './pages/admin/AdminProspects';
import AdminProspectDetail from './pages/admin/AdminProspectDetail';
import AdminClicks from './pages/admin/AdminClicks';
import AdminUsers from './pages/admin/AdminUsers';
import AdminDiscover from './pages/admin/AdminDiscover';
import AdminPipeline from './pages/admin/AdminPipeline';
import { AdminAuthProvider, useAdminAuth } from './pages/admin/AuthContext';

function RequireAdminRole({ children }) {
  const { user } = useAdminAuth();
  if (!user || user.role !== 'admin') return <Navigate to="/admin" replace />;
  return children;
}

function App() {
  const location = useLocation();
  const fullScreen = location.pathname.startsWith('/demos/')
    || location.pathname.startsWith('/p/')
    || location.pathname.startsWith('/audit/')
    || location.pathname.startsWith('/admin');

  return (
    <div className="min-h-screen flex flex-col bg-bg text-text font-sans">
      {!fullScreen && <Header />}
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/demos" element={<Demos />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/demos/:slug" element={<DemoPage />} />
          <Route path="/p/:token" element={<ProspectDemoPage />} />
          <Route path="/audit/:token" element={<AuditPage />} />

          <Route path="/admin/*" element={
            <AdminAuthProvider>
              <Routes>
                <Route path="login" element={<AdminLogin />} />
                <Route element={<AdminLayout />}>
                  <Route index element={<AdminDashboard />} />
                  <Route path="discover" element={<AdminDiscover />} />
                  <Route path="pipeline" element={<AdminPipeline />} />
                  <Route path="prospects" element={<AdminProspects />} />
                  <Route path="prospects/:id" element={<AdminProspectDetail />} />
                  <Route path="clicks" element={<AdminClicks />} />
                  <Route path="users" element={
                    <RequireAdminRole><AdminUsers /></RequireAdminRole>
                  } />
                </Route>
              </Routes>
            </AdminAuthProvider>
          } />
        </Routes>
      </main>
      {!fullScreen && <Footer />}
    </div>
  );
}

export default App;
